import { styled } from '@project44-manifest/react-styles';

export const StyledGridItem = styled('div', { boxSizing: 'border-box' });
